<template>
  <div class="w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-row>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-button class="btn mr-4" type="button" @click="returnPage">
                <span class="svg-icon">
                  <inline-svg
                    src="/media/svg/icons/Neolex/Basic/arrow-left.svg"
                  />
                </span>
                Hủy
              </b-button>
              <b-button
                class="btn btn-success"
                type="button"
                @click="handleValidate"
              >
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
                </span>
                Lưu lại
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <FormTranProgramModuleActivity ref="form" :detail="detail" @submit="submit" />
    </b-overlay>
  </div>
</template>
<script>
export default {
  name: 'TranProgramModuleActivityCreateDetail',
  components: {
    FormTranProgramModuleActivity: () => import('./components/TranProgramModuleActivityCreateDetail.vue'),
  },
  data() {
    return {
      loading: false,
      detail: null,
    };
  },
  created() {
    this.getDataPrepare();
  },
  methods: {
    returnPage() {
      this.$router.go(-1);
    },
    async getDataPrepare() {
      try {
        this.loading = true;
        const { meta, data, error } = await this.$api.get(
          'TranProgramModuleActivity/PrepareCreateUpdateFormItem',
        );
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
            preventDuplicates: true,
          });
        }
        this.detail = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
          preventDuplicates: true,
        });
      } finally {
        this.loading = false;
      }
    },
    handleValidate() {
      this.$refs.form.handleValidate();
    },
    async submit(params) {
      try {
        this.loading = true;        

        const { meta, error } = await this.$api.post(
          '/TranProgramModuleActivity',
          params,
        );
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
            preventDuplicates: true,
          });
        }
        this.$toastr.s({
          title: 'Thành công !',
          msg: `Tạo mới TranProgramModuleActivity thành công`,
        });
        this.returnPage();
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
          preventDuplicates: true,
        });
      } finally {
        this.loading = false;
      }
    },    
  },
};
</script>
<style lang=""></style>
